export const actionTypes = {
  // トースト表示するエラーを追加
  APPEND_TOASTS: 'toasts/APPEND_TOASTS',
  // 指定したトーストを削除
  REMOVE_TOAST: 'toasts/REMOVE_TOAST',
  // すべてのトーストを削除
  CLEAR_TOASTS: 'toasts/CLEAR_TOASTS',
} as const;
